
function matchString(str, arr) {
  if (str == '' || arr.length == 0) {
    return false
  }
  for (let v = 0; v < arr.length; v++) {
    if (str.indexOf(arr[v]) > 0) {
      return true
      break
    }
  }
  return false
}

function isWeixin() { // 判断是否微信
  let ua = navigator.userAgent.toLowerCase()
  let arr = new Array('micromessenger')
  return matchString(ua, arr)
}

// 是否苹果客户端
function isIphone() {
  let ua = navigator.userAgent.toLowerCase()
  let arr = new Array('ipad', 'iphone', 'ipod')
  return matchString(ua, arr)
}

// 是否Android
function isAndroid() {
  let ua = navigator.userAgent.toLowerCase()
  let arr = new Array('android')
  return matchString(ua, arr)
}

function isQQ() {
  let ua = navigator.userAgent.toLowerCase()
  let arr = new Array('qq')
  return matchString(ua, arr)
}

function isWeibo() {
  let ua = navigator.userAgent.toLowerCase()
  let arr = new Array('weibo')
  return matchString(ua, arr)
}

function isHuawei() {
  let ua = navigator.userAgent.toLowerCase()
  let arr = ['huawei', 'honor', 'vog-l29']
  return matchString(ua, arr)
}

function huaWeiOrAndroid() {
  let ua = navigator.userAgent.toLowerCase()
  let arr = ['huawei', 'honor', 'vog-l29']
  let ua2 = navigator.userAgent.toLowerCase()
  let arr2 = new Array('android')

  let isHuawei = matchString(ua, arr)
  let isAndroid = matchString(ua2, arr2)

  return isHuawei ? isHuawei : isAndroid
}

export default {
  isWeixin,
  isIphone,
  isAndroid,
  isQQ,
  isWeibo,
  isHuawei
}



// WEBPACK FOOTER //
// src/helper/brower.js